<template>
    <div class="alert-container">
        
        <section class="alert-list" v-if="filteredAlerts.length">
            <div v-for="alert in filteredAlerts" :key="alert.id">
                    <transition-group name="fade"  appear>
                        <CCAlert v-if="isCC" :alert="alert" :key="alert.id" />
                        <PMBAlert v-else-if="isPMB" :alert="alert" :key="alert.id" />
                        <DAlert v-else-if="isDAT" :alert="alert" :key="alert.id" />
                        <OAAlert v-else-if="isOA" :alert="alert" :key="alert.id" />
                    </transition-group>
            </div>
        </section>
        <div v-else class="no-alerts-message">
            No {{ status }} alerts
        </div>
    </div>
</template>

<script>
import CCAlert from "@/components/alerts/CCAlert"
import PMBAlert from "@/components/alerts/PMBAlert"
import DAlert from "@/components/alerts/DAlert"
import OAAlert from "@/components/alerts/OAAlert"
export default {
	name: "Alertlist",
	props: ['type', 'status', 'alerts'],
	components: {
		CCAlert,
        PMBAlert,
        DAlert,
        OAAlert
	},
    computed: {
        filteredAlerts () {
            const type = `alerts/get_${this.type}_${this.status}`
            const alerts = this.$store.getters[type]
            return alerts || []
        },
        isCC () {
            return this.type === 'cc'
        },
        isPMB () {
            return this.type === 'pmb'
        },
        isDAT () {
            return this.type === 'd'
        },
        isOA () {
            return this.type === 'oa'
        }
    }
}

</script>

<style lang="scss" scoped>
	.alert-container {
        .alert-list {
            margin-bottom: 200px;
        }
        width: 100%; height: 100%;
        padding: 14px;        
        overflow: scroll;	
        .no-alerts-message {
            text-align: center;
            margin-top: 10px;
        }	
        .fade-enter-active, .fade-leave-active {
        transition: opacity 1s;
        }
        .fade-enter, .fade-leave-to {
            opacity: 0;
        }
	}
</style>


// WEBPACK FOOTER //
// src/components/alerts/containers/AlertList.vue